// extracted by mini-css-extract-plugin
export default {"changeLink":"QR-z","disabled":"RR-z","inline":"SR-z"};